// extracted by mini-css-extract-plugin
export default {"promotionalBanner":"PromotionalBanner_promotionalBanner__DT2Uz"};